import { ThemeProvider } from '@mui/material'
import { useMemo } from 'react'
import { createDossTheme } from '../styles/theme'
import { useApplicationOrientation } from './useApplicationOrientation'

/**
 * Provider that sets the application orientation based on the user's settings
 */
export function GlobalThemeProvider({ children }: { children: React.ReactNode }) {
  const { orientation } = useApplicationOrientation()
  const theme = useMemo(() => createDossTheme(orientation), [orientation])

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export function useGlobalTheme() {
  const { orientation } = useApplicationOrientation()
  const theme = useMemo(() => createDossTheme(orientation), [orientation])

  return theme
}
